const getStyles = () => {
  return {
    bannerSection: {
      position: 'relative',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)'
    },

    // Background Layers
    animatedBackground: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)'
    },

    floatingShape1: {
      position: 'absolute',
      top: '80px',
      right: '-128px',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      opacity: 0.4,
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      filter: 'blur(48px)',
      animation: 'pulse 4s ease-in-out infinite'
    },

    floatingShape2: {
      position: 'absolute',
      bottom: '80px',
      left: '-128px',
      width: '384px',
      height: '384px',
      borderRadius: '50%',
      opacity: 0.3,
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      filter: 'blur(48px)',
      animation: 'pulse 4s ease-in-out infinite 1s'
    },

    // Particles
    particle1: {
      position: 'absolute',
      top: '25%',
      left: '25%',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      backgroundColor: '#ffffff',
      opacity: 0.6,
      animation: 'float 3s ease-in-out infinite'
    },

    particle2: {
      position: 'absolute',
      top: '33%',
      right: '25%',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: '#e3f2fd',
      opacity: 0.4,
      animation: 'float 4s ease-in-out infinite 1s'
    },

    particle3: {
      position: 'absolute',
      bottom: '25%',
      left: '33%',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#bbdefb',
      opacity: 0.5,
      animation: 'float 3.5s ease-in-out infinite 0.5s'
    },

    gradientOverlay: {
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(135deg, rgba(10, 34, 90, 0.95) 0%, rgba(33, 99, 210, 0.85) 40%, rgba(125, 195, 255, 0.8) 100%)',
      pointerEvents: 'none',
      zIndex: 10
    },

    // Content Styles
    contentContainer: {
      position: 'relative',
      zIndex: 10,
      padding: { xs: '40px 24px', md: '48px 48px' }
    },

    gridContainer: {
      minHeight: '100vh',
      padding: { xs: '40px 0', md: '80px 0' }
    },

    // Image Section
    imageContainer: {
      position: 'relative',
      '&:hover $imageGlow': {
        opacity: 0.4
      }
    },

    imageGlow: {
      position: 'absolute',
      inset: '-16px',
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      opacity: 0.3,
      filter: 'blur(48px)',
      borderRadius: '24px',
      transition: 'opacity 0.5s ease'
    },

    mainImage: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '24px',
      boxShadow: '0 25px 50px -12px rgba(12, 90, 219, 0.4)',
      transition: 'transform 0.6s ease'
      // '&:hover': {
      //   transform: 'scale(1.05)'
      // }
    },

    imageOverlay: {
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(135deg, rgba(12, 90, 219, 0.3) 0%, rgba(58, 142, 246, 0.3) 100%)',
      mixBlendMode: 'overlay'
    },

    floatingBadge: {
      position: 'absolute',
      bottom: '-24px',
      right: '-24px',
      backdropFilter: 'blur(20px)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '16px',
      padding: '16px 24px',
      boxShadow: '0 25px 50px -12px rgba(12, 90, 219, 0.3)'
    },

    // Content Section
    contentSection: {
      position: 'relative',
      gap: '32px',
      display: 'flex',
      flexDirection: 'column'
    },

    premiumBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      backdropFilter: 'blur(12px)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '9999px',
      padding: '8px 16px',
      marginBottom: '24px'
    },

    mainTitle: {
      fontWeight: 'bold',
      marginBottom: '24px',
      background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      fontSize: { xs: '3rem', md: '4rem', lg: '5rem' },
      lineHeight: 1.2,
      textShadow: '0 4px 8px rgba(12, 90, 219, 0.3)'
    },

    description: {
      marginBottom: '40px',
      gap: '16px',
      display: 'flex',
      flexDirection: 'column'
    },

    descriptionText: {
      fontSize: { xs: '1rem', md: '1.125rem' },
      color: 'rgba(255, 255, 255, 0.9)',
      lineHeight: 1.7,
      '& span': {
        color: '#ffffff',
        fontWeight: 600,
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
      }
    },

    // Stats Section
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: { xs: '16px', md: '24px' },
      '@media (max-width: 768px)': {
        gridTemplateColumns: 'repeat(1, 1fr)'
      }
    },

    statCard: {
      position: 'relative',
      '&:hover': {
        transform: 'translateY(-5px)'
      },
      transition: 'transform 0.3s ease'
    },

    statGlow: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      opacity: 0,
      borderRadius: '12px',
      filter: 'blur(20px)',
      transition: 'opacity 0.5s ease'
    },

    statContent: {
      position: 'relative',
      backdropFilter: 'blur(12px)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.25)',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 10px 25px -5px rgba(12, 90, 219, 0.3)',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.4)',
        '& $statGlow': {
          opacity: 0.3
        }
      }
    },

    statValue: {
      fontSize: { xs: '1.875rem', md: '2.25rem' },
      fontWeight: 'bold',
      background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      marginBottom: '4px',
      textShadow: '0 2px 4px rgba(12, 90, 219, 0.3)'
    },

    statLabel: {
      fontSize: { xs: '0.75rem', md: '0.875rem' },
      color: 'rgba(255, 255, 255, 0.8)',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },

    bottomFade: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '128px',
      background:
        'linear-gradient(to top, rgba(12, 90, 219, 0.8) 0%, transparent 100%)',
      pointerEvents: 'none',
      zIndex: 20
    },

    // Additional blue-themed elements
    badgeText: {
      fontSize: { xs: '0.875rem', md: '1rem' },
      color: '#ffffff',
      fontWeight: 500
    },

    successRate: {
      fontSize: { xs: '1.5rem', md: '1.875rem' },
      fontWeight: 'bold',
      background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent'
    },

    successLabel: {
      fontSize: { xs: '0.75rem', md: '0.875rem' },
      color: 'rgba(255, 255, 255, 0.8)',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },

    // Animation keyframes
    '@keyframes pulse': {
      '0%, 100%': {
        opacity: 0.4,
        transform: 'scale(1)'
      },
      '50%': {
        opacity: 0.6,
        transform: 'scale(1.05)'
      }
    },

    '@keyframes float': {
      '0%, 100%': {
        transform: 'translateY(0px) rotate(0deg)'
      },
      '33%': {
        transform: 'translateY(-20px) rotate(120deg)'
      },
      '66%': {
        transform: 'translateY(-10px) rotate(240deg)'
      }
    },

    '@keyframes glow': {
      '0%, 100%': {
        boxShadow: '0 0 20px rgba(12, 90, 219, 0.5)'
      },
      '50%': {
        boxShadow:
          '0 0 40px rgba(12, 90, 219, 0.8), 0 0 60px rgba(58, 142, 246, 0.6)'
      }
    }
  };
};

export default getStyles;
